module.exports = __webpack_public_path__ + "static/media/media-owner-benefit-flat-2-1.de716b51.svg";